import React, { useState, useEffect, Fragment } from 'react';
import client from '@/lib/feathers';
import { useSelector } from 'react-redux';
import {
  Table,
  Button,
  Dialog,
  Message,
  Checkbox,
  Input,
  Pagination,
} from '@alifd/next';
import { Form, InputNumber, Select, Upload } from 'antd';
import ReactDragListView from 'react-drag-listview';
import axios from 'axios';
import Swal from 'sweetalert2';
import { DeleteOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
import DownloadButton from '@/components/UI/DownloadButton';

const { Option } = Select;
function BADeviceList() {
  const [form] = Form.useForm();
  const baDevice = client.service('baDevice');
  const categoryMenu = client.service('categoryMenu');
  const broadcastBoxs = client.service('broadcastBoxs');
  const publicInformationHour = client.service('publicInformationHour');
  const publicInformationCount = client.service('publicInformationCount');
  const [categoryForm] = Form.useForm();
  const user = useSelector((state) => state.user);
  const [allowedFuncs, setAllowedFuncs] = useState([]);
  const [arrDiv, setArrDiv] = useState([]);
  const [checkedData, setCheckedData] = useState([]);
  const [targetFilters, setTargetFilters] = useState([]);
  const [baDeviceUpdateDialog, setBaDeviceUpdateDialog] = useState(false);
  const [baDeviceId, setBaDeviceId] = useState(0);
  const [baDeviceObj, setBaDeviceObj] = useState({});
  const [isUpdate, setIsUpdate] = useState(false);

  // 編輯裝置群組
  const [editable, setEditable] = useState('');
  const [categoryDataArr, setCategoryDataArr] = useState([]);
  const [categoryDialog, setCategoryDialog] = useState(false);
  const [categoryId, setCategoryId] = useState('');
  const [broadcastBoxArr, setBroadcastBoxArr] = useState([]);
  const [publicArr, setPublicArr] = useState([]);
  const [broadcastType, setBroadcastType] = useState([]);
  const [type, setType] = useState(['郵件包裹', '寄放物品', '公設點數']);
  const [currentOutPage, setCurrentOutPage] = useState(1);
  const indexOfLastPostOut = currentOutPage * 10;
  const indexOfFirstPostOut = indexOfLastPostOut - 10;
  const currentPostsOut = arrDiv.slice(indexOfFirstPostOut, indexOfLastPostOut);
  useEffect(() => {
    if (user.userGroup.key) {
      const checkedKeys = user.userGroup.key.checkedKeys;
      setAllowedFuncs(checkedKeys);
    }
  }, [user]);

  function baRemoveById(id = '', sort) {
    return new Promise(async (resolve, reject) => {
      try {
        if (id === '') throw new Error('錯誤!資料沒有ID!');
        const Res = await baDevice.remove(id);
        const tarFilters = [];
        setArrDiv(
          [...arrDiv]
            .filter((e) => e._id !== Res._id)
            .map((i) => {
              if (i.hasOwnProperty('baIp') && !tarFilters.includes(i.baIp))
                tarFilters.push(i.baIp);
              return {
                ...i,
                sort: i.sort > sort ? i.sort - 1 : i.sort, // 刪除的該筆sort < this.sort ? this.sort -1 : this.sort
              };
            })
        );
        setTargetFilters(tarFilters);
        setCheckedData(
          [...checkedData].slice(0, checkedData.length - 1).map(() => false)
        ); // 勾選全部改false
        return resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  function baRemoveByNames() {
    // Remove many by name
    return new Promise(async (resolve, reject) => {
      try {
        // 找到所勾選資料之 name Array合集
        const tarArr = [...arrDiv]
          .map((e, nb) => {
            return checkedData[nb] ? e.name : false;
          })
          .filter((i) => i !== false);

        const Res = await baDevice.remove(null, {
          query: {
            name: { $in: tarArr },
          },
        });
        if (!Res || Res.length === 0) return resolve(0);
        const resElems = [...Res].map((i) => i._id);
        const resSorts = [];
        const tarFilters = [];
        setArrDiv(
          [...arrDiv]
            .filter((e) => {
              // 把已移除data filter
              if (resElems.includes(e._id)) {
                // 移除的data
                if (e.hasOwnProperty('sort')) resSorts.push(e.sort); // 移除data的sort值
                return false;
              }
              return true;
            })
            .map((i) => {
              // 改變還存在data的sort值
              const changeVal = resSorts.reduce((all, now) => {
                return now < i.sort ? all + 1 : all + 0;
              }, 0); // 已刪除data中,sort比this.sort小的總數
              if (i.hasOwnProperty('baIp') && !tarFilters.includes(i.baIp))
                tarFilters.push(i.baIp);
              return {
                ...i,
                sort: i.sort - changeVal, // 移除後 相關資料sort改變
              };
            })
        );
        setTargetFilters(tarFilters);
        setCheckedData(
          [...checkedData]
            .slice(0, checkedData.length - resElems.length)
            .map(() => false)
        );
        return resolve(resElems.length);
      } catch (error) {
        reject(error);
      }
    });
  }

  function handleChange(value) {
    // filter add check
    setCheckedData(
      [...arrDiv].map((i, nb) => {
        if (!i.hasOwnProperty('baIp')) return checkedData[nb];
        if (value.includes(i.baIp)) return true;
        return false;
      })
    );
  }

  function onFilterRemove(tarObj) {
    // filter remove check
    setCheckedData(
      [...arrDiv].map((i, nb) => {
        if (!i.hasOwnProperty('baIp')) return checkedData[nb];
        if (tarObj.value === i.baIp) return false;
        return checkedData[nb];
      })
    );
  }

  useEffect(() => {
    (async () => {
      try {
        const baReliabilityResult = await axios('/ezcon/api/baReliability', {
          method: 'GET',
          headers: {
            authorization: window.localStorage['feathers-jwt'],
          },
        });
        const tarFilters = [];
        setArrDiv(
          [...baReliabilityResult.data].map((i, nb) => {
            if (i.hasOwnProperty('baIp') && !tarFilters.includes(i.baIp))
              tarFilters.push(i.baIp);
            return {
              ...i,
              sort: nb + 1,
            };
          })
        );
        setTargetFilters(tarFilters);
        setCheckedData([...baReliabilityResult.data].map(() => false));

        const broadcastBoxsRes = await broadcastBoxs.find({});
        setBroadcastBoxArr(broadcastBoxsRes.data);

        let publicArr = [];
        const publicInformationCountRes = await publicInformationCount.find({});
        publicArr.push(...publicInformationCountRes.data);
        const publicInformationHourRes = await publicInformationHour.find({});
        publicArr.push(...publicInformationHourRes.data);
        setPublicArr(publicArr);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [isUpdate, broadcastBoxs]);

  const onFinish = (value) => {
    console.log(value);
    baDevice
      .patch(baDeviceId, {
        ...value,
        broadcastType,
        broadcastId: value.broadcastId === undefined ? null : value.broadcastId,
        publicId:
          value.publicId === undefined ||
          broadcastType.indexOf('郵件包裹') >= 0 ||
          broadcastType.indexOf('寄放物品') >= 0
            ? null
            : value.publicId,
      })
      .then(() => {
        Message.success('修改成功');
        setIsUpdate((pre) => !pre);
        setBaDeviceUpdateDialog(false);
      });
  };

  useEffect(() => {
    (async () => {
      const categoryData = await categoryMenu.find({
        query: { service: 'baDevice' },
      });
      setCategoryId(categoryData.data[0]._id);
      setCategoryDataArr(categoryData.data[0].data);
    })();
  }, [isUpdate, categoryMenu]);

  const onDragCategoryEnd = async (fromIndex, toIndex) => {
    if (toIndex < 0) return; // Ignores if outside designated area
    const items = categoryDataArr; // 所有類別資料
    const item = items.splice(fromIndex, 1)[0];
    items.splice(toIndex, 0, item); // 把刪除的新增到移動的位置
    try {
      await categoryMenu.patch(categoryId, {
        data: items,
      });
      Message.success('更新成功');
      setIsUpdate((prev) => !prev);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div style={{ display: 'inline-flex' }}>
        <Select
          mode="multiple"
          allowClear
          onChange={handleChange}
          placeholder="主機Ip選擇"
          style={{ width: 250, marginBottom: '10px' }}
        >
          {targetFilters.map((item, index) => (
            <Option value={item} key={index}>
              {item}
            </Option>
          ))}
        </Select>

        <Button
          type="secondary"
          className={styles.btn}
          onClick={() => {
            // reduce(陣列運算回傳累加值)
            // -----------------全累加,該值----如果是true:累加+1,false則不加--起始累加值(空陣列不帶會報錯)
            const nowSelectedCtn = checkedData.reduce((all, now) => {
              return now ? all + 1 : all + 0;
            }, 0);
            if (nowSelectedCtn > 0)
              setCheckedData([...checkedData].map(() => false));
            // 勾選全部改false
            else {
              setCheckedData([...checkedData].map(() => true));
            }
          }}
        >
          全選/取消全選
        </Button>

        <Button
          type="secondary"
          className={styles.btn}
          onClick={() => {
            const nowSelectedCtn = checkedData.reduce((all, now) => {
              return now ? all + 1 : all + 0;
            }, 0);
            if (nowSelectedCtn === 0) {
              Message.warning('勾選項目不得為空!');
            } else {
              Swal.fire({
                title: '確定刪除所選裝置資料?',
                text: '刪除後無法復原!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#BEBEBE',
                confirmButtonText: '確定',
                cancelButtonText: '取消',
              }).then(async (result) => {
                if (result.isConfirmed) {
                  await baRemoveByNames().then((len) => {
                    Swal.fire('成功!', `刪除${len}筆資料成功`, 'success');
                  });
                }
              });
            }
          }}
        >
          刪除已選取
        </Button>
        <Button
          type="secondary"
          className={styles.btn}
          onClick={() => {
            setCategoryDialog(true);
          }}
        >
          編輯裝置群組
        </Button>
        <DownloadButton
          {...{
            buttonProps: {
              type: 'secondary',
              style: {
                marginLeft: '10px',
              },
            },
            url: '/ezcon/api/baDeviceTableTextAndTableGroupExcelData',
            headers: {
              authorization: localStorage.getItem('feathers-jwt'),
            },
            fileName: `下載BA Excel.xlsx`,
            responseFileType:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          }}
        >
          匯出Excel
        </DownloadButton>
        <Upload
          showUploadList={false}
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          customRequest={async (options) => {
            const { file } = options;
            const formData = new FormData();
            formData.append('files', file);
            try {
              await axios.patch(
                '/ezcon/api/baDeviceTableTextAndTableGroup',
                formData,
                {
                  headers: {
                    authorization: window.localStorage['feathers-jwt'],
                  },
                }
              );
              Message.success('上傳成功');
              setIsUpdate((pre) => !pre);
            } catch (error) {
              console.error(error);
              Message.error('上傳失敗');
            }
          }}
        >
          <Button className={styles.btn} type="secondary">
            匯入Excel
          </Button>
        </Upload>
      </div>
      {/* 裝置群組 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={categoryDialog}
        onOk={async () => {
          try {
            await categoryMenu.patch(categoryId, {
              data: categoryDataArr,
            });
            Message.success('更新成功');
            setCategoryDialog(false);
            setIsUpdate((prev) => !prev);
          } catch (error) {
            console.log(error);
          }
        }}
        onCancel={() => {
          setCategoryDialog(false);
          setIsUpdate((prev) => !prev);
        }}
        onClose={() => {
          setCategoryDialog(false);
          setIsUpdate((prev) => !prev);
        }}
      >
        <Form
          layout="inline"
          form={categoryForm}
          onFinish={(value) => {
            const newArr = [...categoryDataArr];
            newArr.push(value.categoryName);
            setCategoryDataArr(newArr);
            categoryForm.resetFields();
          }}
        >
          <Form.Item
            label="類別名稱"
            name="categoryName"
            rules={[
              {
                required: true,
                message: '請輸入類別名稱',
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              onClick={() => {
                categoryForm.submit();
              }}
            >
              新增
            </Button>
          </Form.Item>
        </Form>
        <p>可拖曳表格欄位變換類別順序</p>
        <div style={{ marginTop: 10 }}>
          <ReactDragListView onDragEnd={onDragCategoryEnd}>
            <Table dataSource={categoryDataArr}>
              <Table.Column
                title="類別"
                width={250}
                cell={(_value, index) => {
                  if (editable === index) {
                    return (
                      <Input
                        value={categoryDataArr[index]}
                        onChange={(value) => {
                          const newData = [...categoryDataArr];
                          newData[index] = value;
                          setCategoryDataArr(newData);
                        }}
                      />
                    );
                  } else {
                    return <span>{categoryDataArr[index]}</span>;
                  }
                }}
              />
              <Table.Column
                title="操作"
                width={200}
                lock="right"
                cell={(_value, index, record) => {
                  return (
                    <div className={styles.categoryBtn}>
                      {editable === index ? (
                        <Button
                          type="normal"
                          onClick={() => {
                            setEditable('');
                          }}
                        >
                          確定
                        </Button>
                      ) : (
                        <Button
                          type="normal"
                          onClick={() => {
                            setEditable(index);
                          }}
                        >
                          編輯
                        </Button>
                      )}

                      <Button
                        type="primary"
                        warning
                        onClick={async () => {
                          const result = await Swal.fire({
                            title: `確定刪除此類別(${record})?`,
                            text: '刪除後將無法復原!!',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#BEBEBE',
                            confirmButtonText: '確定',
                            cancelButtonText: '取消',
                          });
                          if (result.isConfirmed) {
                            try {
                              await categoryMenu.patch(categoryId, {
                                $pull: { data: record },
                              });
                              Message.success('刪除成功');
                              setIsUpdate((prev) => !prev);
                            } catch (error) {
                              console.log(error);
                            }
                          }
                        }}
                      >
                        刪除
                      </Button>
                    </div>
                  );
                }}
              />
            </Table>
          </ReactDragListView>
        </div>
      </Dialog>

      <Table
        dataSource={currentPostsOut}
        onSort={(dataIndex, order) => {
          const dataSource = arrDiv.sort(function (a, b) {
            let result = 0;
            if (
              typeof a[dataIndex] === 'number' &&
              typeof b[dataIndex] === 'number'
            ) {
              // for Number Sort
              result = a[dataIndex] - b[dataIndex];
            } else if (
              typeof a[dataIndex] !== 'undefined' &&
              typeof b[dataIndex] !== 'undefined'
            ) {
              // 排序的data都要有該key值
              result = (
                typeof a[dataIndex] === 'number'
                  ? a[dataIndex].toString()
                  : a[dataIndex]
              ).localeCompare(
                typeof b[dataIndex] === 'number'
                  ? b[dataIndex].toString()
                  : b[dataIndex]
              );
            } else {
              // deal data沒有該key值
              result =
                (a[dataIndex] ? JSON.stringify(a[dataIndex]).length : 0) -
                (b[dataIndex] ? JSON.stringify(b[dataIndex]).length : 0);
            }
            // const result = a[dataIndex] - b[dataIndex];
            return order === 'asc'
              ? result > 0
                ? 1
                : -1
              : result > 0
              ? -1
              : 1;
          });
          // console.log("==Final Sorted====",dataSource);
          setArrDiv(dataSource);
          setCheckedData([...checkedData].map(() => false)); // 勾選全部改false
        }}
      >
        <Table.Column
          title="順序"
          dataIndex="sort"
          sortable
          width={60}
          lock="left"
        />
        <Table.Column
          title="選取"
          width={60}
          lock="left"
          cell={(_value, index) => {
            return (
              <>
                <Checkbox
                  checked={checkedData[index]}
                  onChange={(checked) => {
                    setCheckedData(
                      [...checkedData].map((e, nb) => {
                        if (index === nb) return checked;
                        else {
                          return e;
                        }
                      })
                    );
                  }}
                />
              </>
            );
          }}
        />
        <Table.Column
          title="裝置名稱"
          width={160}
          dataIndex="tableText"
          sortable
        />
        <Table.Column
          title="裝置群組"
          width={120}
          dataIndex="tableGroup"
          sortable
        />
        {/* <Table.Column title="裝置代號" width={140} dataIndex="name" sortable /> */}
        {/* <Table.Column
          title="裝置類別"
          width={120}
          dataIndex="category"
          sortable
        /> */}
        <Table.Column title="BA主機ip" width={120} dataIndex="baIp" sortable />
        <Table.Column
          title="BA主機Route"
          width={140}
          dataIndex="baUrl"
          sortable
        />
        <Table.Column
          title="BA主機埠號"
          width={100}
          dataIndex="baPort"
          sortable
        />
        <Table.Column
          title="顯示"
          width={150}
          dataIndex="sync"
          sortable
          cell={(_value, _index, record) => {
            if (record.isShow === false && record.isControl === false) {
              return '不顯示';
            }
            if (record.isShow === true && record.isControl === true) {
              return '顯示可控制';
            }
            if (record.isShow === true && record.isControl === false) {
              return '顯示數值';
            }
          }}
        />
        <Table.Column
          title="BA語音對應種類"
          width={100}
          dataIndex="broadcastType"
          cell={(value) => {
            if (value !== undefined) {
              return value.join(',');
            }
          }}
        />
        {allowedFuncs.includes('智慧建築專區') && (
          <Table.Column
            title="BA錯誤次數"
            width={100}
            dataIndex="error"
            sortable
          />
        )}
        {allowedFuncs.includes('智慧建築專區') && (
          <Table.Column
            title="BA可靠度最大值"
            width={100}
            dataIndex="reliabilityMax"
            sortable
          />
        )}
        {allowedFuncs.includes('智慧建築專區') && (
          <Table.Column
            title="可靠率"
            width={100}
            dataIndex="reliability"
            sortable
            cell={(record) => `${record}%`}
          />
        )}
        <Table.Column
          title="操作"
          width={200}
          lock="right"
          cell={(_value, _index, record) => {
            return (
              <>
                {record._id ? (
                  <div className={styles.btnGroup}>
                    <Button
                      onClick={() => {
                        setBaDeviceUpdateDialog(true);
                        form.setFieldsValue({
                          ...record,
                        });
                        setBaDeviceId(record._id);
                        setBaDeviceObj(record);
                        setBroadcastType(record?.broadcastType);
                      }}
                    >
                      編輯
                    </Button>

                    <Button
                      type="secondary"
                      className={styles.exportBtn}
                      onClick={() => {
                        Swal.fire({
                          title: `確定刪除<br>裝置名稱:${record.tableText}?`,
                          text: '刪除後無法復原!',
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#BEBEBE',
                          confirmButtonText: '確定',
                          cancelButtonText: '取消',
                        }).then(async (result) => {
                          if (result.isConfirmed) {
                            await baRemoveById(record._id, record.sort).then(
                              () => {
                                Swal.fire('成功!', `刪除成功`, 'success');
                              }
                            );
                          }
                        });
                      }}
                    >
                      刪除
                    </Button>
                  </div>
                ) : (
                  ''
                )}
              </>
            );
          }}
        />
      </Table>
      <Pagination
        className={styles.pagination}
        total={arrDiv.length}
        pageSize={10}
        totalRender={(total) => `Total: ${total}`}
        onChange={(pageNumber) => {
          setCurrentOutPage(pageNumber);
        }}
      />

      {/* 20220701 編輯可靠度功能  */}
      <Dialog
        className={styles.dialog}
        visible={baDeviceUpdateDialog}
        onOk={() => form.submit()}
        onClose={() => setBaDeviceUpdateDialog(false)}
        onCancel={() => setBaDeviceUpdateDialog(false)}
      >
        <h1>編輯BA裝置</h1>
        <Form onFinish={onFinish} form={form}>
          <Form.Item
            name="tableText"
            label="裝置名稱"
            rules={[
              {
                required: true,
                message: '請輸入裝置名稱',
              },
            ]}
          >
            <Input style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            name="tableGroup"
            label="裝置群組"
            rules={[
              {
                required: true,
                message: '請輸入裝置群組',
              },
            ]}
          >
            <Select>
              {categoryDataArr.map((item, index) => (
                <Option key={index} value={item}>
                  {item}
                </Option>
              ))}
            </Select>
          </Form.Item>
          {baDeviceObj.group === '門禁' && (
            <>
              <Form.Item
                name="playType"
                label="播放方式"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select allowClear style={{ width: '100%' }}>
                  <Option value="sort">全部播放</Option>
                  <Option value="priority">單一播放</Option>
                </Select>
              </Form.Item>
              <Form.Item
                name="broadcastId"
                label="對應公播"
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <Select allowClear style={{ width: '100%' }}>
                  {broadcastBoxArr.map((item, index) => (
                    <Option value={item._id} key={index}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="語音播放種類"
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <Button
                  style={{ marginBottom: 10 }}
                  onClick={() => {
                    console.log(broadcastType.indexOf('公設點數'));
                    const temp = [...broadcastType];
                    if (
                      broadcastType.length < 3 ||
                      (broadcastType.indexOf('公設點數') >= 0 &&
                        broadcastType.length === 1)
                    ) {
                      temp.push([]);
                      setBroadcastType(temp);
                    }
                    if (temp.length > 1) {
                      if (
                        broadcastType.indexOf('郵件包裹') >= 0 ||
                        broadcastType.indexOf('寄放物品') >= 0
                      )
                        setType(['郵件包裹', '寄放物品']);

                      if (broadcastType.indexOf('公設點數') >= 0)
                        setType(['公設點數']);
                    } else {
                      setType(['郵件包裹', '寄放物品', '公設點數']);
                    }
                  }}
                >
                  新增播放種類
                </Button>
                {broadcastType.map((item, index) => (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginBottom: 10,
                      alignItems: 'center',
                    }}
                  >
                    <div> {index + 1}.</div>
                    <div style={{ width: '90%' }}>
                      <Select
                        allowClear
                        style={{ width: '100%' }}
                        value={item}
                        onChange={(value) => {
                          const temp = [...broadcastType];
                          temp[index] = value;
                          setBroadcastType(temp);
                        }}
                      >
                        {type.map((e) => {
                          if (broadcastType.indexOf(e) === -1) {
                            return <Option value={e}>{e}</Option>;
                          }
                        })}

                        {/* <Option value="寄放物品">寄放物品</Option>
                        <Option value="公設點數">公設點數</Option> */}
                      </Select>
                    </div>
                    <div>
                      <DeleteOutlined
                        onClick={() => {
                          const temp = [...broadcastType];
                          temp.splice(index, 1);
                          setBroadcastType(temp);
                          if (temp.length === 1)
                            setType(['郵件包裹', '寄放物品', '公設點數']);
                        }}
                      />
                    </div>
                  </div>
                ))}
              </Form.Item>
              {broadcastType.indexOf('公設點數') >= 0 && (
                <Form.Item
                  name="publicId"
                  label="對應公設"
                  rules={[
                    {
                      required: false,
                    },
                  ]}
                >
                  <Select allowClear style={{ width: '100%' }}>
                    {publicArr.map((item, index) => (
                      <Option value={item._id} key={index}>
                        {item.publicName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </>
          )}
          {allowedFuncs.includes('智慧建築專區') && (
            <Form.Item
              name="reliabilityMax"
              label="可靠度最大值"
              rules={[
                {
                  required: true,
                  message: '請輸入可靠度最大值',
                },
              ]}
            >
              <InputNumber />
            </Form.Item>
          )}
        </Form>
      </Dialog>
    </>
  );
}

export default BADeviceList;
